import React from 'react'
import * as R from 'ramda'

import StaffOnly from 'components/auth/StaffOnly'
import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { Accounts } from './common/Accounts/Accounts'
import { Admin } from './common/Admin/Admin'
import { Languages } from './common/Languages/Languages'
import { Logout } from './common/Logout/Logout'

export const UserProfileMenu = ({
  accounts,
  activeAccount,
  activeLanguage,
  languages,
  onClickAdmin,
  onLogOut,
  onSwitchAccount,
  onSwitchLanguage,
}) => (
  <Dropdown.Menu>
    <Languages {...{ activeLanguage, languages, onSwitchLanguage }} />
    {R.gt(R.length(accounts), 0) ? (
      <Accounts {...{ activeAccount, accounts, onSwitchAccount }} />
    ) : null}
    <StaffOnly>
      <Admin {...{ onClickAdmin }} />
    </StaffOnly>
    <Logout {...{ onLogOut }} />
  </Dropdown.Menu>
)
